// Module
var code = "<!-- ko descendantsComplete: $component.onRender.bind($component) -->\n<button class=\"btn-question\" data-bind=\"stopClick, tooltipText: text, tooltip, tooltipClick, tooltipPlacement: 'top'\" type=\"button\"></button>\n<!-- /ko -->\n";
// Exports
module.exports = code;